import React from 'react'
import styles from './Media.module.css'


const ProgressBar = ({duration, curTime, onTimeUpdate, keyMomentsData, keyMomentSelectedId, currentSpeakerData}: any) => {

    const curPercentage = (curTime / duration) * 100;

    const calcClickedTime = (e: any) => {
        const clickPositionInPage = e.pageX;
        const bar = document.querySelector(".bar-progress") as HTMLElement;
        const barStart = bar.getBoundingClientRect().left + window.scrollX;
        const barWidth = bar.offsetWidth;
        const clickPositionInBar = clickPositionInPage - barStart;
        const timePerPixel = duration / barWidth;
        return timePerPixel * clickPositionInBar;
      }
    
    const handleTimeDrag = (e?: React.MouseEvent<HTMLDivElement ,MouseEvent>) => {
        onTimeUpdate(calcClickedTime(e));
    
        const updateTimeOnMove = (eMove: any) => {
          onTimeUpdate(calcClickedTime(eMove));
        };
    
        document.addEventListener("mousemove", updateTimeOnMove);
    
        document.addEventListener("mouseup", () => {
          document.removeEventListener("mousemove", updateTimeOnMove);
        });
    }

    const keyMoments = keyMomentsData && keyMomentsData.length > 0 && keyMomentsData.map((moment: {[key: string]: any}) => {
      return moment.time.length > 0 && moment.time.map((time: number) => {
        let offset = time/duration*100
        return <span key={time} className={`${styles.momentPoint} ${moment.id === keyMomentSelectedId ? styles.selected : '' }`} style={{left: `${offset}%`}}></span>
      })
    })

    return (
        <div>
          <div className={styles.momentsPoints}>
            {keyMoments}
          </div>
          <div className={styles.mediaBar}>
            <div
                className={`${styles.barProgress} bar-progress`}
                style={{
                background: `linear-gradient(to right, #063eff ${curPercentage}%, #e8ecf6 0)`
                }}
                onMouseDown={e => handleTimeDrag(e)}
            >
                <div className={styles.barProgressKnob} style={{ left: `${curPercentage - 1}%` }}>
                  {
                    currentSpeakerData && currentSpeakerData.speakerIndex >= 0 &&
                    <span className={styles.barProgressLine} style={{ height: `${(currentSpeakerData.speakerIndex + 1) * 52}px` }}></span>
                  }
                </div>
            </div>
        </div>
        </div>
    )
}

export default ProgressBar
